import { useEffect, useState } from 'react';
import usePmSensorAuthId from 'components/hooks/PM/usePmSensorAuthId';
import _ from 'lodash';
import useResourceAllocationService from 'common/services/resource-allocation.service.versions';

const useAvailability = () => {
  const raService = useResourceAllocationService();
  const pmSensorAuthId = usePmSensorAuthId();
  const [isEmptyState, setIsEmptyState] = useState(false);

  const fetchAvailabiliy = async () => {
    try {
      const res = await raService.getAvailability({
        sensor_authorization_id: pmSensorAuthId
      });
      const isDataAvailable = _.get(res, 'data_available');
      setIsEmptyState(isDataAvailable === false);
    } catch (e) {
      setIsEmptyState(true);
    }
  };

  useEffect(() => {
    fetchAvailabiliy();
  }, []);

  return {
    isEmptyState
  };
};

export default useAvailability;
